'use client'

import classnames from 'classnames'
import styles from './OrderInquiryForm.module.scss'
import OrderInquiryForm from '@/components/OrderInquiryForm/OrderInquiryForm'
import Widont from '@/components/Widont/Widont'

type OrderInquiryFormSectionProps = {
  className?: string
  title?: string
  subtitle?: string
}

const OrderInquiryFormSection = ({ className, subtitle, title }: OrderInquiryFormSectionProps) => {
  if (!title) return null

  return (
    <div className={classnames(styles.OrderInquiryForm, className)}>
      <div className={classnames(styles.inner)}>
        <div className={styles.textContainer}>
          <h1 className={styles.title}>
            <Widont text={title} />
          </h1>
          {subtitle && (
            <p className={styles.subtitle}>
              <Widont text={subtitle} />
            </p>
          )}
        </div>
        <div className={styles.formContainer}>
          <OrderInquiryForm />
        </div>
      </div>
    </div>
  )
}

OrderInquiryFormSection.displayName = 'OrderInquiryFormSection'

export default OrderInquiryFormSection
